import React from "react";
import { FaHourglassHalf } from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { MdVerified } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getApi } from "../pages/AppApis";
import { useEffect } from "react";
import { useState } from "react";

export default function VerificationRejectionReason({ verificationStatus, setVerificationPopupVisible, rejection_reason }) {
    const navigate = useNavigate();
    const [verificationData, setVerificationData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const getVerificationData = async () => {
        try {
            setLoading(true);
            const response = await getApi("/verifications/user-verifications", true);
            setVerificationData(response?.response.data.company_verifications);
        } catch (error) {
            console.error("Error fetching verification data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getVerificationData();
    }, []);

    return (
        <div
            onClick={() => setVerificationPopupVisible(false)}
            style={{ zIndex: 1500 }}
            className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black/50 tw-p-4 tw-min-h-screen"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="tw-bg-white tw-shadow-lg tw-rounded-[20px] tw-p-10 max-sm:tw-p-6 tw-max-w-[500px] max-sm:tw-max-w-[95vw] tw-w-full tw-max-h-[85vh] max-sm:tw-max-h-[80vh] tw-overflow-y-auto tw-my-auto"
            >
                <h3 className="tw-text-center tw-text-black tw-font-[700] tw-text-[28px] max-sm:tw-text-[24px]">
                    Your Verification is {verificationStatus?.toUpperCase()}
                </h3>
                <hr className="tw-mt-2 tw-mb-5 tw-w-full tw-bg-border_color tw-h-1" />
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="tw-flex tw-items-center tw-gap-3 tw-text-[16px] tw-text-black tw-max-h-[300px] tw-overflow-y-scroll">
                            <p> {rejection_reason ?? `Your Verification is ${verificationStatus?.toUpperCase()}`}</p>
                        </div>
                        <div className="tw-flex tw-items-center tw-justify-between tw-gap-5 max-sm:tw-flex-col max-sm:tw-gap-3">
                            <button
                                onClick={() => navigate("/chat")}
                                className="tw-bg-[#E0ECF9] tw-mt-10 max-sm:tw-mt-6 tw-text-black tw-rounded-md tw-h-[48px] max-sm:tw-h-[44px] tw-flex tw-items-center tw-justify-center tw-w-[80%] max-sm:tw-w-full tw-self-center max-sm:tw-text-sm"
                            >
                                Contact Support
                            </button>
                            <button
                                onClick={() => navigate("/start-verification")}
                                className="tw-bg-primary tw-mt-10 max-sm:tw-mt-3 tw-text-white tw-rounded-md tw-h-[48px] max-sm:tw-h-[44px] tw-flex tw-items-center tw-justify-center tw-w-[80%] max-sm:tw-w-full tw-self-center max-sm:tw-text-sm"
                            >
                                Retry Verification
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
